export default function getAdPrice(ad: any): number {
  return Number(
    ad.ad_auction?.current_bid
      ? ad.ad_auction.current_bid.amount
      : ad.ad_auction?.amount_start
        ? ad.ad_auction.amount_start
        : ad.price
          ? ad.price
          : 0
  );
}
